import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../components/Container';
const launch = [{
  n: '01',
  label: 'We configure your workflows',
  sub: 'Checklists, forms, and templates built to match how your team operates today.'
}, {
  n: '02',
  label: 'We integrate your systems',
  sub: 'Policy admin, document management, CRM. Wired up by our team, no lift from yours.'
}, {
  n: '03',
  label: 'We support every rollout',
  sub: 'A dedicated team owns your account from day one through every program and line.'
}];
export function TrustAndLaunch() {
  return <section className="py-20 sm:py-28" data-id="element-938">
      <Container data-id="element-939">
        <div className="grid gap-10 lg:grid-cols-[5fr_7fr] lg:gap-16" data-id="element-940">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '400px'
        }} transition={{
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-941">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent" data-id="element-942">
              Implementation
            </div>
            <h2 className="mt-4 font-serif-display text-5xl leading-[1.0] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-943">
              <span className="italic text-accent" data-id="element-944">No lift</span>
              <br data-id="element-945" />
              from your tech team.
            </h2>
          </motion.div>

          <ol className="relative" data-id="element-946">
            {launch.map((l, i) => <motion.li key={l.n} initial={{
            opacity: 0,
            x: 8
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '400px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08,
            ease: [0.16, 1, 0.3, 1]
          }} className="relative grid grid-cols-[auto_1fr] items-start gap-5 pb-10 last:pb-0" data-id="element-947">
                {i < launch.length - 1 && <div aria-hidden className="pointer-events-none absolute left-[1.125rem] top-9 bottom-0 w-px bg-gradient-to-b from-accent/40 to-accent/15" data-id="element-948" />}
                <div className="relative z-10 flex h-9 w-9 items-center justify-center rounded-full border border-accent/30 bg-zinc-950 font-mono text-[11px] text-accent" data-id="element-949">
                  {l.n}
                </div>
                <div className="pt-1" data-id="element-950">
                  <h3 className="text-lg font-semibold tracking-tight text-white sm:text-xl" data-id="element-951">
                    {l.label}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-zinc-400" data-id="element-952">
                    {l.sub}
                  </p>
                </div>
              </motion.li>)}
          </ol>
        </div>
      </Container>
    </section>;
}